import React from 'react';
import styled from 'styled-components';

const TableCellHyperLink = ({ visibleFilename, base64data }) => {
  const onClick = () => {
    const newTab = window.open('');
    newTab.document.write(`<iframe width="100%" height="100%" src="data:application/pdf;base64,${base64data}"></iframe>`);
  };
  return <Wrapper onClick={onClick}>{visibleFilename}</Wrapper>;
};

export default TableCellHyperLink;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 30px;
  text-decoration: underline;
  cursor: pointer;
  color: var(--primary);
`;
